var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"tag":"section"}},[_c('h3',{staticClass:"mb-2 text-center text-h3"},[_vm._v(_vm._s(_vm.$t('ads.ad')))]),_c('v-row',{staticClass:"my-0"},_vm._l((_vm.maxCount),function(position){return _c('ad-item',{key:position,attrs:{"ad":_vm.getAdForPosition(position)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }